"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ActionButton_1 = __importDefault(require("./ActionButton"));
var DetailsButton_1 = __importDefault(require("./DetailsButton"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Buttons = function (_a) {
    var userType = _a.userType, onlyAction = _a.onlyAction;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.container, " ").concat(onlyAction ? styles_module_scss_1.default.onlyAction : '') },
        react_1.default.createElement(ActionButton_1.default, null),
        !onlyAction && react_1.default.createElement(DetailsButton_1.default, { userType: userType })));
};
exports.default = Buttons;
